/* import __COLOCATED_TEMPLATE__ from './reason-cards-list.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import type { ReportState } from 'embercom/components/reporting/custom/report/chart-card';
import type { Job } from 'embercom/components/reporting/automation/ai-insights/optimize/jobs';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    reportState: ReportState;
    selectedJob: Job;
    selectedJobId: string;
    availableJobs: Job[];
    onOpenSectionChange: (jobId: string) => void;
    taskSuggestions?: TaskSuggestion[];
  };
}

const ReasonCardsList = templateOnlyComponent<Signature>();
export default ReasonCardsList;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::ReasonCardsList': typeof ReasonCardsList;
    'reporting/automation/ai-insights/optimize/reason-cards-list': typeof ReasonCardsList;
  }
}
